import { useQuery } from '@tanstack/react-query';
import { queryKey } from '../../../../../constant/queryKey';
import { marketService } from 'shared/src/api';

export const useMarketAiStudioProductInfo = (marketId: number) => {
  return useQuery({
    queryKey: queryKey.marketAiStudioProductInfo(marketId),
    queryFn: () => marketService.getMarketAiStudioProductInfo(marketId),
  });
};
